import * as React from 'react';
import * as ReactDOM from 'react-dom';
//Need to polyfill for IE 11
import 'core-js';
import 'react-app-polyfill/ie9'; // tslint:disable-line
import 'react-app-polyfill/stable'; // tslint:disable-line
import { Provider } from 'react-redux';
import store from './state/utils/createStore';
import routes from './state/utils/routerWrapper';
import { GlobalStyle } from './globalStyle';
import { tokenManager } from 'coral-utility';

tokenManager.register('instrument-library');

ReactDOM.render(
  <Provider store={store}>
    {routes}
    <GlobalStyle />
  </Provider>,
  document.getElementById('root') as HTMLElement
);
